import { FC } from 'react';
import { Chip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ICreditResultItemProps } from './types';
import { CreditDataTable } from './CreditDataTable';

const handleConvertToStartCase = (str: string): string =>
  str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ')
    .trim();

const chipPropsMapper: Record<string, Record<string, string>> = {
  ZERO: { label: '0', color: 'success' },
  ONE: { label: '1', color: 'warning' },
  TWO: { label: '2', color: 'warning' },
  THREE: { label: '3', color: 'error' },
  FOUR: { label: '4', color: 'error' },
  FIVE: { label: '5', color: 'error' },
  SIX: { label: '6', color: 'error' },
  U: { label: 'U', color: 'default' },
};

export const CreditResultItem: FC<ICreditResultItemProps> = ({
  title,
  forename,
  type,
  middleName,
  surname,
  startDate,
  lastUpdateDate,
  fixedPaymentTerms,
  paymentAmount,
  paymentFrequency,
  dateOfBirth,
  endDate,
  history,
  currentBalance,
  defaultBalance,
  startBalance,
}) => (
  <div>
    <Typography component={'span'} className={'my-8'} variant='h5'>
      {title} {forename} {middleName} {surname} - {handleConvertToStartCase(type)}
    </Typography>

    <CreditDataTable
      startDate={startDate}
      lastUpdateDate={lastUpdateDate}
      fixedPaymentTerms={fixedPaymentTerms}
      paymentAmount={paymentAmount}
      paymentFrequency={paymentFrequency}
      dateOfBirth={dateOfBirth}
      endDate={endDate}
      currentBalance={currentBalance}
      defaultBalance={defaultBalance}
      startBalance={startBalance}
    />

    <Typography component={'span'} className={'my-8'} variant='h6'>
      <FormattedMessage id={'credit.paymentHistory'} />
    </Typography>

    <div className={'mb-10 border border-x-0 border-t-0 border-solid pb-10'}>
      <div className={'grid-cols-24 grid rounded-sm border-2 border-solid'}>
        {history.map(({ paymentStatus, ageInMonths }, index) => {
          const chipProps = chipPropsMapper[paymentStatus] || { label: paymentStatus, color: 'success' };

          return (
            <div key={ageInMonths} className={'flex flex-col items-center rounded-sm border border-solid'}>
              <div className={'flex w-full justify-center border-0 border-b border-solid p-1'}>
                <Typography component={'span'} variant='h6'>
                  {index + 1}
                </Typography>
              </div>
              <div className={'flex p-2'}>
                <Chip className={'rounded-sm text-lg'} {...chipProps} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);
